import { Controller, Control, FieldErrors } from "react-hook-form";
import { Autocomplete, TextField, Box } from "@mui/material";
import { Label } from "@/components";
import { TagTypeTagV2 } from "@/types/tagsV2";
import { UserV2FormValues } from "@/modules/admin/sidebar/UserV2/UserFormV2";

interface ProviderFieldProps {
  control: Control<UserV2FormValues>;
  errors: FieldErrors<UserV2FormValues>;
  providerOptions: TagTypeTagV2[];
  defaultValue?: string;
}

export function ProviderField({
  control,
  errors,
  providerOptions,
  defaultValue = "",
}: ProviderFieldProps) {
  return (
    <Box>
      <Label label="Provider*">
        <Controller
          name="providerName"
          defaultValue={defaultValue}
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={providerOptions.map((provider) => provider.name)}
              renderInput={(params) => (
                <TextField error={!!errors.providerName} {...params} />
              )}
              value={field.value}
              onInputChange={(_event, newValue) => field.onChange(newValue)}
              freeSolo
              clearOnBlur={false}
              sx={{
                "& .MuiInputBase-root": {
                  height: "40px",

                  "& .MuiInputBase-input": {
                    fontSize: "20px",
                  },
                },
              }}
            />
          )}
        />
      </Label>
      {!!errors.providerName && (
        <p style={{ fontSize: "13px", letterSpacing: ".5px" }}>
          {errors.providerName.message}
        </p>
      )}
    </Box>
  );
}
